export default __webpack_public_path__ + "static/media/PlasmaGasTableImg.2a6103d2.jpg";